// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-property-grid',
    emits: ['refresh'],
    // #endregion
    // #region Properties
    props: {
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: null
        },
    },
    data: () => ({
        editMode: false,
        _forms: {}
    }),
    // #endregion
    // #region Methods
    methods: {
        // #region Helper
        getFormContext(category) {
            if (!this._forms[category.name]) {
                this._forms[category.name] = {
                    validation: this.$utils.getValidationManager(this),
                    original: {}
                };
            }
            return this._forms[category.name];
        },
        getDisplayName(category, property) {
            if (!category.editMode) {
                return property.displayName;
            }
            if (!property.isRequired) {
                return property.displayName;
            }
            return property.displayName + "*";
        },
        getDataDisplayName(data, category, property) {
            let tValue = '';
            if (property.expressions?.label) {
                tValue = utils.getObjectValue(data, property.expressions.label);
            }
            else {
                tValue = property.displayName;
            }
            if (!category.editMode) {
                return tValue;
            }
            if (!property.isRequired) {
                return tValue;
            }
            return tValue + "*";
        },
        getEditFieldType(property) {
            if (!property.fieldType) {
                return "g-text-field";
            }
            else if (property.fieldType === "select") {
                return "g-select-field";
            }
            return "g-select-field";
        },
        isVisibleCategory(category) {
            if (!category.condition) {
                return true;
            }
            return utils.evalExpression({ category: category, data: this.data }, category.condition);
        },
        isVisible(category, property) {
            if (!property.visibility || property.visibility === 0) {
                return true;
            }
            if (property.visibility === 1) {
                return false;
            }
            if (property.visibility === 2) {
                if (category.editMode) {
                    return true;
                }
                else if (utils.getObjectValue(this.data, property.name)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return true;
        },
        isDataVisible(data, category, property) {
            if (!property.visibility || property.visibility === 0) {
                return true;
            }
            if (property.visibility === 1) {
                return false;
            }
            if (property.visibility === 2) {
                if (category.editMode) {
                    return true;
                }
                else if (utils.getObjectValue(data, property.expressions?.member ?? property.name)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return true;
        },
        getArrayValue(property) {
            return utils.getObjectValue(this.data, property) ?? [];
        },
        getCellValue(property) {
            // #region Get
            let tValue = utils.getObjectValue(this.data, property.name);
            // #endregion
            // #region Empty
            if (!tValue) {
                return "--";
            }
            // #endregion
            // #region Lookup
            if (property?.attributes?.itemSource) {
                let tItem = property.attributes.itemSource.find(e => e[property.attributes.valueExpr] == tValue);
                if (tItem) {
                    tValue = utils.evalExpression(tItem, property.attributes.displayExpr);
                }
            }
            // #endregion
            // #region Format
            if (property.dataType === "date" || property.dataType === "date?") {
                tValue = utils.formatDate(Date.parse(tValue), "date");
            }
            else if (property.dataType === "datetime" || property.dataType === "datetime?") {
                tValue = utils.formatDate(Date.parse(tValue), "date-shorttime");
            }
            // #endregion
            return tValue;
        },
        getDataCellValue(data, property) {
            // #region Get
            let tValue = utils.getObjectValue(data, property?.expressions?.member ?? property.name);
            // #endregion
            // #region Empty
            if (!tValue) {
                return "--";
            }
            // #endregion
            // #region Lookup
            if (property?.attributes?.itemSource) {
                let tItem = property.attributes.itemSource.find(e => e[property.attributes.valueExpr] == tValue);
                if (tItem) {
                    tValue = utils.evalExpression(tItem, property.attributes.displayExpr);
                }
            }
            // #endregion
            // #region Format
            if (property.dataType === "date" || property.dataType === "date?") {
                tValue = utils.formatDate(Date.parse(tValue), "date");
            }
            else if (property.dataType === "datetime" || property.dataType === "datetime?") {
                tValue = utils.formatDate(Date.parse(tValue), "date-shorttime");
            }
            // #endregion
            return tValue;
        },
        // #endregion
        // #region Commands
        onEditClick(category) {
            // #region Data
            let tForm = this.getFormContext(category);
            if (category.properties) {
                category.properties.forEach((e) => {
                    utils.setObjectValue(tForm.original, e.name, utils.getObjectValue(this.data, e.name));
                });
            }
            // #endregion
            // #region Mode
            category.editMode = true;
            // #endregion
        },
        async onCommandClick(cmd) {
            if (cmd.mode === 'action') {
                if (!cmd.command) {
                    return;
                }
                if (!await host.actions.tryExecute(cmd.command)) {
                    return;
                }
            }
            if (cmd.refreshMode === 'full') {
                this.$emit("refresh");
            }
        },
        onSaveClick(category) {
            // #region Start
            category.isWorking = true;
            // #endregion
            // #region Check
            if (!category._links?.updates?.href) {
                category.isWorking = false;
                return;
            }
            // #endregion
            // #region Validation
            let tForm = this._forms[category.name];
            {
                if (tForm?.validation && !tForm.validation.validate()) {
                    category.isWorking = false;
                    return;
                }
            }
            // #endregion
            // #region Data
            let tData = {};
            if (category.properties) {
                category.properties.forEach((e) => {
                    utils.setObjectValue(tData, e.name, utils.getObjectValue(this.data, e.name));
                });
            }
            // #endregion
            // #region Upload                
            //Url
            let tUrl = utils.evalExpression({ data: this.data, category: category }, '`' + category._links.updates.href + '`');
            //Run
            host.api
                .request({
                url: tUrl,
                method: category._links.updates?.method ?? 'PUT',
                data: tData
            })
                .then(e => {
                category.editMode = false;
                category.isWorking = false;
            })
                .catch(e => {
                host.notification.showError(e);
            });
            // #endregion
        },
        onCancelClick(category) {
            // #region Data
            let tForm = this.getFormContext(category);
            if (category.properties) {
                //Reset
                category.properties.forEach((e) => {
                    if (!e.isReadOnly) {
                        utils.setObjectValue(this.data, e.name, utils.getObjectValue(tForm.original, e.name));
                    }
                });
                //Reset
                tForm.original = {};
            }
            // #endregion
            // #region Mode
            category.editMode = false;
            // #endregion
        },
        // #endregion
    }
    // #endregion
});
// #endregion
